function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Box, Divider } from '@chakra-ui/layout';
import { Spinner } from '@chakra-ui/spinner';
import { useStyleConfig, useStyles } from '@chakra-ui/system';
import React from 'react';
import { CaretDownIcon, CaretUpIcon, CloseIcon } from './icons';
export var IndicatorSeparator = props => {
  var {
    className,
    cx,
    selectProps: {
      chakraStyles
    }
  } = props;
  var initialStyles = {
    opacity: 1
  };
  var sx = chakraStyles != null && chakraStyles.indicatorSeparator ? chakraStyles.indicatorSeparator(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Divider, {
    className: cx({
      'indicator-separator': true
    }, className),
    orientation: "vertical",
    sx: sx
  });
};
export var DropdownIndicator = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    selectProps: {
      menuIsOpen,
      size,
      chakraStyles
    }
  } = props;
  var {
    addon
  } = useStyles();
  var iconSizes = {
    xs: 4,
    sm: 4,
    md: 5,
    lg: 6
  };
  var iconSize = iconSizes[size];
  var Icon = menuIsOpen ? CaretUpIcon : CaretDownIcon;

  var initialStyles = _extends({}, addon, {
    d: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    h: '100%',
    borderRadius: 0,
    borderWidth: 0,
    cursor: 'pointer',
    bg: 'transparent',
    px: 2,
    color: 'brand.500'
  });

  var sx = chakraStyles != null && chakraStyles.dropdownIndicator ? chakraStyles.dropdownIndicator(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Box, _extends({}, innerProps, {
    className: cx({
      indicator: true,
      'dropdown-indicator': true
    }, className),
    sx: sx
  }), children || /*#__PURE__*/React.createElement(Icon, {
    h: iconSize,
    w: iconSize
  }));
};
export var ClearIndicator = props => {
  var {
    children,
    className,
    cx,
    innerProps,
    isFocused,
    selectProps: {
      size,
      chakraStyles
    }
  } = props;
  var closeButtonStyles = useStyleConfig('CloseButton', {
    size
  });

  var initialStyles = _extends({}, closeButtonStyles, {
    marginX: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    cursor: 'pointer'
  });

  var sx = chakraStyles != null && chakraStyles.clearIndicator ? chakraStyles.clearIndicator(initialStyles, props) : initialStyles; // const initialIconStyles: SystemStyleObject = {
  //   width: '1em',
  //   height: '1em',
  // }
  // const iconSx: SystemStyleObject = chakraStyles?.crossIcon
  //   ? chakraStyles.crossIcon(initialIconStyles, props)
  //   : initialIconStyles

  return /*#__PURE__*/React.createElement(Box, _extends({
    "aria-label": "Clear selected options",
    className: cx({
      indicator: true,
      'clear-indicator': true
    }, className),
    "data-focused": isFocused ? true : undefined,
    role: "button",
    sx: sx
  }, innerProps), children || /*#__PURE__*/React.createElement(CloseIcon, {
    height: "1em",
    width: "1em"
  }));
};
export var LoadingIndicator = props => {
  var {
    className,
    cx,
    innerProps,
    selectProps: {
      size,
      chakraStyles
    },
    color,
    emptyColor,
    speed,
    thickness,
    spinnerSize: propsSpinnerSize
  } = props;
  var spinnerSizes = {
    xs: 'xs',
    sm: 'xs',
    md: 'sm',
    lg: 'md'
  };
  var spinnerSize = spinnerSizes[size];
  var initialStyles = {
    mr: 3,
    color: 'cheese'
  };
  var sx = chakraStyles != null && chakraStyles.loadingIndicator ? chakraStyles.loadingIndicator(initialStyles, props) : initialStyles;
  return /*#__PURE__*/React.createElement(Spinner, _extends({
    className: cx({
      indicator: true,
      'loading-indicator': true
    }, className),
    sx: sx
  }, innerProps, {
    color: color,
    emptyColor: emptyColor,
    size: propsSpinnerSize || spinnerSize,
    speed: speed,
    thickness: thickness
  }));
};
//# sourceMappingURL=indicators.js.map